import React, { lazy, Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Loading from 'components/shared-components/Loading';

export const OnboardingViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" fallback={true} />}>
      <>
        <Route path={'/onboarding'} component={lazy(() => import('./onboarding'))} />
        <Redirect from=" " to="/onboarding" />
      </>
    </Suspense>
  )
}

export default React.memo(OnboardingViews);